/**
 * レポートの記録者表示名を返す。
 * v3 系 API のレスポンスは記録者を principal (User/共用端末アカウント共通) で持ち、
 * v1 系レスポンスや既存の state は assignee (User) で持つため、principal 優先で解決する。
 * どちらも無い場合は空文字。
 */
type RecorderSource = {
  principal?: { name?: string } | null
  assignee?: { name?: string } | null
}

export const getRecorderName = (report: RecorderSource): string =>
  report.principal?.name ?? report.assignee?.name ?? ''
